import { ref } from 'vue'

const locale = ref('tr')

const messages = {
  tr: {
    appTitle: 'Pine Etkinlikler',
    appSubtitle: 'Halk oylaması ve soru akışı',
    home: 'Ana Sayfa',
    language: 'Dil',
    eventLoading: 'Etkinlik yükleniyor...',
    viewWinner: 'Kazananı görüntüle',
    loadingEventDetails: 'Etkinlik detayları yükleniyor...',
    eventNotFound: 'Etkinlik bulunamadı.',
    eventNotFinished: 'Etkinlik henüz bitmedi.',
    eventLoadFailed: 'Etkinlik yüklenemedi.',
    start: 'Başlangıç',
    end: 'Bitiş',
    voteScope: 'Oylama kapsamı',
    items: 'Öğeler',
    shortCode: 'Kısa kod',
    active: 'Aktif',
    passive: 'Pasif',
    totalScore: 'Toplam puan',
    openQuestions: 'Soruları aç',
    shortCodeRequired: 'Soruları açmak için kısa kod gereklidir.',
    winner: 'Kazanan',
    backToEvent: 'Etkinliğe dön',
    loadingResults: 'Sonuçlar yükleniyor...',
    loadResultsFailed: 'Etkinlik sonuçları yüklenemedi.',
    topItem: 'En iyi öğe',
    noScoredItems: 'Henüz puanlanmış öğe yok.',
    allScoredItems: 'Tüm puanlanmış öğeler',
    questions: 'Sorular',
    itemLoading: 'Öğe yükleniyor...',
    loadingQuestions: 'Sorular yükleniyor...',
    itemOrEventNotFound: 'Öğe veya etkinlik bulunamadı.',
    questionsLoadFailed: 'Sorular yüklenemedi.',
    required: 'Zorunlu',
    rating: 'Puan (1–5)',
    selectOption: 'Bir seçenek seçin',
    answer: 'Cevap',
    submitAnswers: 'Cevapları gönder',
    reviewAnswers: 'Lütfen cevaplarınızı gözden geçirin ve tekrar deneyin.',
    submitFailed: 'Gönderim başarısız oldu. Lütfen tekrar deneyin.',
    alreadySubmitted: 'Zaten gönderim yaptınız.',
    submitted: 'Gönderildi',
    thanks: 'Cevaplarınız için teşekkürler',
    responsesRecorded: ' için yanıtlarınız kaydedildi.',
    viewQuestions: 'Soruları görüntüle',
    itemNotFound: 'Öğe bulunamadı.',
    itemDetailsFailed: 'Öğe detayları yüklenemedi.',
    eventExplorer: 'Etkinlik Gezgini',
    enterSlug: 'Öğeleri ve soruları görüntülemek için bir etkinlik slug\'ı girin.',
    eventSlug: 'Etkinlik slug',
    openEvent: 'Etkinliği aç',
    pages: 'Sayfalar',
    eventPage: 'Etkinlik sayfası',
    winnerPage: 'Kazanan sayfası',
    itemQuestions: 'Öğe soruları',
    itemSubmitted: 'Öğe gönderildi',
    businessInfo: 'İşletme bilgileri',
    businessName: 'İşletme adı',
    businessOwner: 'İşletme sahibi',
    logoLabel: 'Logo',
    socialLinks: 'Sosyal linkler',
    hashtags: 'Hashtagler',
    eventHashtags: 'Etkinlik hashtagleri'
  },
  en: {
    appTitle: 'Pine Events',
    appSubtitle: 'Public voting and question flow',
    home: 'Home',
    language: 'Language',
    eventLoading: 'Loading event...',
    viewWinner: 'View winner',
    loadingEventDetails: 'Loading event details...',
    eventNotFound: 'Event not found.',
    eventNotFinished: 'Event is not finished yet.',
    eventLoadFailed: 'Unable to load the event.',
    start: 'Starts',
    end: 'Ends',
    voteScope: 'Vote scope',
    items: 'Items',
    shortCode: 'Short code',
    active: 'Active',
    passive: 'Inactive',
    totalScore: 'Total score',
    openQuestions: 'Open questions',
    shortCodeRequired: 'Short code is required to open questions.',
    winner: 'Winner',
    backToEvent: 'Back to event',
    loadingResults: 'Loading results...',
    loadResultsFailed: 'Unable to load event results.',
    topItem: 'Top item',
    noScoredItems: 'No scored items available yet.',
    allScoredItems: 'All scored items',
    questions: 'Questions',
    itemLoading: 'Loading item...',
    loadingQuestions: 'Loading questions...',
    itemOrEventNotFound: 'Item or event not found.',
    questionsLoadFailed: 'Unable to load questions.',
    required: 'Required',
    rating: 'Rating (1–5)',
    selectOption: 'Select an option',
    answer: 'Answer',
    submitAnswers: 'Submit answers',
    reviewAnswers: 'Please review your answers and try again.',
    submitFailed: 'Submission failed. Please retry.',
    alreadySubmitted: 'You have already submitted.',
    submitted: 'Submitted',
    thanks: 'Thanks for your answers',
    responsesRecorded: ' responses have been recorded for ',
    viewQuestions: 'View questions',
    itemNotFound: 'Item not found.',
    itemDetailsFailed: 'Unable to load item details.',
    eventExplorer: 'Event Explorer',
    enterSlug: 'Enter an event slug to view items and questions.',
    eventSlug: 'Event slug',
    openEvent: 'Open event',
    pages: 'Pages',
    eventPage: 'Event page',
    winnerPage: 'Winner page',
    itemQuestions: 'Item questions',
    itemSubmitted: 'Item submitted',
    businessInfo: 'Business info',
    businessName: 'Business name',
    businessOwner: 'Business owner',
    logoLabel: 'Logo',
    socialLinks: 'Social links',
    hashtags: 'Hashtags',
    eventHashtags: 'Event hashtags'
  },
  ar: {
    appTitle: 'فعاليات باين',
    appSubtitle: 'التصويت العام وتدفق الأسئلة',
    home: 'الرئيسية',
    language: 'اللغة',
    eventLoading: 'جاري تحميل الفعالية...',
    viewWinner: 'عرض الفائز',
    loadingEventDetails: 'جاري تحميل تفاصيل الفعالية...',
    eventNotFound: 'لم يتم العثور على الفعالية.',
    eventNotFinished: 'لم تنتهِ الفعالية بعد.',
    eventLoadFailed: 'تعذر تحميل الفعالية.',
    start: 'البداية',
    end: 'النهاية',
    voteScope: 'نطاق التصويت',
    items: 'العناصر',
    shortCode: 'الرمز المختصر',
    active: 'نشط',
    passive: 'غير نشط',
    totalScore: 'إجمالي النقاط',
    openQuestions: 'فتح الأسئلة',
    shortCodeRequired: 'الرمز المختصر مطلوب لفتح الأسئلة.',
    winner: 'الفائز',
    backToEvent: 'العودة إلى الفعالية',
    loadingResults: 'جاري تحميل النتائج...',
    loadResultsFailed: 'تعذر تحميل نتائج الفعالية.',
    topItem: 'أفضل عنصر',
    noScoredItems: 'لا توجد عناصر مُقيّمة بعد.',
    allScoredItems: 'جميع العناصر المُقيّمة',
    questions: 'الأسئلة',
    itemLoading: 'جاري تحميل العنصر...',
    loadingQuestions: 'جاري تحميل الأسئلة...',
    itemOrEventNotFound: 'لم يتم العثور على العنصر أو الفعالية.',
    questionsLoadFailed: 'تعذر تحميل الأسئلة.',
    required: 'إلزامي',
    rating: 'التقييم (1–5)',
    selectOption: 'اختر خيارًا',
    answer: 'الإجابة',
    submitAnswers: 'إرسال الإجابات',
    reviewAnswers: 'يرجى مراجعة إجاباتك والمحاولة مرة أخرى.',
    submitFailed: 'فشل الإرسال. يرجى المحاولة مرة أخرى.',
    alreadySubmitted: 'لقد أرسلت بالفعل.',
    submitted: 'تم الإرسال',
    thanks: 'شكرًا لإجاباتك',
    responsesRecorded: ' تم تسجيل إجاباتك لـ ',
    viewQuestions: 'عرض الأسئلة',
    itemNotFound: 'العنصر غير موجود.',
    itemDetailsFailed: 'تعذر تحميل تفاصيل العنصر.',
    eventExplorer: 'مستكشف الفعاليات',
    enterSlug: 'أدخل معرّف الفعالية لعرض العناصر والأسئلة.',
    eventSlug: 'معرّف الفعالية',
    openEvent: 'فتح الفعالية',
    pages: 'الصفحات',
    eventPage: 'صفحة الفعالية',
    winnerPage: 'صفحة الفائز',
    itemQuestions: 'أسئلة العنصر',
    itemSubmitted: 'تم إرسال العنصر',
    businessInfo: 'معلومات النشاط التجاري',
    businessName: 'اسم النشاط التجاري',
    businessOwner: 'مالك النشاط التجاري',
    logoLabel: 'الشعار',
    socialLinks: 'روابط التواصل الاجتماعي',
    hashtags: 'الوسوم',
    eventHashtags: 'وسوم الفعالية'
  },
  es: {
    appTitle: 'Eventos Pine',
    appSubtitle: 'Votación pública y flujo de preguntas',
    home: 'Inicio',
    language: 'Idioma',
    eventLoading: 'Cargando evento...',
    viewWinner: 'Ver ganador',
    loadingEventDetails: 'Cargando detalles del evento...',
    eventNotFound: 'Evento no encontrado.',
    eventNotFinished: 'El evento aún no ha terminado.',
    eventLoadFailed: 'No se pudo cargar el evento.',
    start: 'Inicio',
    end: 'Fin',
    voteScope: 'Alcance de votación',
    items: 'Elementos',
    shortCode: 'Código corto',
    active: 'Activo',
    passive: 'Inactivo',
    totalScore: 'Puntuación total',
    openQuestions: 'Abrir preguntas',
    shortCodeRequired: 'Se requiere el código corto para abrir preguntas.',
    winner: 'Ganador',
    backToEvent: 'Volver al evento',
    loadingResults: 'Cargando resultados...',
    loadResultsFailed: 'No se pudieron cargar los resultados.',
    topItem: 'Mejor elemento',
    noScoredItems: 'Aún no hay elementos puntuados.',
    allScoredItems: 'Todos los elementos puntuados',
    questions: 'Preguntas',
    itemLoading: 'Cargando elemento...',
    loadingQuestions: 'Cargando preguntas...',
    itemOrEventNotFound: 'Elemento o evento no encontrado.',
    questionsLoadFailed: 'No se pudieron cargar las preguntas.',
    required: 'Obligatorio',
    rating: 'Calificación (1–5)',
    selectOption: 'Selecciona una opción',
    answer: 'Respuesta',
    submitAnswers: 'Enviar respuestas',
    reviewAnswers: 'Revisa tus respuestas e inténtalo de nuevo.',
    submitFailed: 'El envío falló. Inténtalo de nuevo.',
    alreadySubmitted: 'Ya has enviado.',
    submitted: 'Enviado',
    thanks: 'Gracias por tus respuestas',
    responsesRecorded: ' se han registrado tus respuestas para ',
    viewQuestions: 'Ver preguntas',
    itemNotFound: 'Elemento no encontrado.',
    itemDetailsFailed: 'No se pudieron cargar los detalles del elemento.',
    eventExplorer: 'Explorador de eventos',
    enterSlug: 'Ingresa el slug del evento para ver elementos y preguntas.',
    eventSlug: 'Slug del evento',
    openEvent: 'Abrir evento',
    pages: 'Páginas',
    eventPage: 'Página del evento',
    winnerPage: 'Página del ganador',
    itemQuestions: 'Preguntas del elemento',
    itemSubmitted: 'Elemento enviado',
    businessInfo: 'Información del negocio',
    businessName: 'Nombre del negocio',
    businessOwner: 'Propietario del negocio',
    logoLabel: 'Logo',
    socialLinks: 'Enlaces sociales',
    hashtags: 'Hashtags',
    eventHashtags: 'Hashtags del evento'
  }
}

const getMessage = (key) => messages[locale.value]?.[key] ?? messages.tr[key] ?? key

export function useI18n() {
  const t = (key) => getMessage(key)
  return {
    locale,
    t
  }
}
